import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Tooltip, Typography } from 'antd';
import { CheckOutlined } from '@ant-design/icons';

const { Text } = Typography;

const CustomerIdCell = ({ customerId,linkText, copied, handleCopy }) => {
  const customerData = useMemo(() => {
    if (typeof customerId === 'string' && customerId.length > 16) {
      return `${customerId.substring(0, 4)}....${customerId.substring(customerId.length - 4)}`;
    }
    return customerId || '';
  }, [customerId]);

  return (
    <dev>
      {customerId && copied !== customerId && (
        <Text
          key={customerId}
          className="text-light-valueColor flex justify-between"
          copyable={{ text: customerId, onCopy: () => handleCopy(customerId) }}
          options={{ format: 'text/plain' }}
        >
         <span className={linkText ==="link" ?'text-link':'text-subTextColor'}>{customerData}</span>
        </Text>
      )}
      {copied === customerId && (
        <Text className="flex justify-between" key={customerId}>
          <span className={linkText ==="link" ?'text-link':'text-subTextColor'}>{customerData}</span>
          <Tooltip title="Copied" open={copied === customerId}>
            <CheckOutlined style={{ marginLeft: 8, color: 'green' }} />
          </Tooltip>
        </Text>
      )}
      </dev>
  );
};

CustomerIdCell.propTypes = {
  customerId: PropTypes.string,
};

CustomerIdCell.defaultProps = {
  customerId: '',
};

export default CustomerIdCell;
